module.exports = __webpack_public_path__ + "assets/img/04-m.bb80330.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/04-m.jpg
// module id = EtNK
// module chunks = 0